import React, { useState, useEffect, useContext, useRef, use } from "react";
import { MobileView,isMobile } from "react-device-detect";
import ItemInPanier from "./ItemPanier";
import {useFetch} from "../../api/FetchApiData";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Paypal from "./paypal/Paypal";
import { Rating } from "react-simple-star-rating";
import { useNavigate } from "react-router-dom";
import { MediaUrl } from "../../utils/media/Media";
import panierIcon from '../../icons/panier.webp';
import cashIcon from '../../icons/cash.webp';
import deliveryIcon from '../../icons/delivry.webp';
import creditIcon from '../../icons/cartebleu.webp';
import dixmilleIcon from '../../icons/10000.webp';
import infoIcon from '../../icons/info_icon.webp';
import home_icon from '../../map/icons/home.webp';
import { useTranslation } from "react-i18next";
import giftcard_icon from '../../icons/gift.png';
import { AppContext } from "../../../AppContextProvider";
import { ButtonLoader } from "../../utils/Loaders/ButtonLoader";

if (isMobile)
    import('./panier_mob.css').then(() => {});
else
    import('./panier.css').then(() => {});

export default function Panier({User,setUser})
{
    const [panier,setPanier] = useState({prices:{total:0,delivery:0},articles:[],delivers:[],gift_cards:[]});
    const [addresses,setAddresses] = useState([]);
    const [mes_addresses, setMesAddresses] = useState([]);
    const [selAddress,setSelAddress] = useState(null);
    const [AppState,setAppState] = useContext(AppContext);
    const orArticlesRef = useRef([]);
    const [notif,setNotif] = useState("")
    const {t} = useTranslation();
    const [mapContex,setMapContext] = useState({display:'block',btnText:'-',loading:false,points:[]});    
    const refCashPaymentBtn = useRef(null);
    const GiftOptionLabel = (gift)=>{
        return(
            <div  style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',fontSize:'small',background:'transparent'}}>
                <div style={{display:'block',textAlign:'center',width:'25%',verticalAlign:'middle',margin:'0px 10px 0px 0px',background:'transparent'}}>
                    <img src={giftcard_icon} style={{width:'40px',borderRadius:'5px',margin:'auto',marginRight:'15px'}} />
                </div>
                <div style={{maxWidth:'70%',margin:'0px auto 0px 7px',padding:'0px',verticalAlign:'middle'}}>
                    <h5 style={{margin:'0px',marginBottom:'3px',padding:'0px'}}><span style={{marginRight:'10px'}}>{gift.card_number}</span></h5>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <span style={{padding:'0px',color:'gray',fontSize:'x-small',display:'block',textDecoration:!!(gift.remaining)?'line-through':'none'}}>{gift.value}</span>
                        {!!(gift.remaining) && <span style={{marginLeft:'10px',padding:'0px',color:'green',fontSize:'x-small',display:'block'}}>{gift.remaining}</span>}
                        <span style={{marginLeft:'10px',padding:'0px',color:'gray',fontSize:'x-small',display:'block'}}>{AppState.settings.devise==='euro'?'€':'KMF'}</span>
                    </div>
                </div>
            </div>
        );
    }

    const [giftsCards,setGiftCards] = useState([]);

    const navigator = useNavigate();

    const fetchData = useFetch();
    
    const PartnerOption = (location,is_partner=false)=>{
        if(!is_partner)
        {
            return(
            <div key={location.label} className="select-option" style={{fontSize:'small'}}>
                <img src={home_icon} style={{margin:'auto',width:'30px',height:'30px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                    <label style={{fontSize:'xx-small'}}>{location.label}</label><br/>
                    <span style={{color:'rgb(120,120,120)',fontSize:'xx-small'}}>{location.display_name}</span>
                </div>
            </div>);
        }
        else
        {
            return(
                <div key={location.name} style={{fontSize:'small'}}>
                    <div style={{display:'inline-block',verticalAlign:'middle',maxWidth:'50px'}}>
                        <div style={{margin:'auto',marginBottom:'-6px'}}>
                            <img src={MediaUrl(location.logo.image)} style={{margin:'auto',width:'25px',height:'20px',borderRadius:'10px'}} />
                        </div>
                        <Rating st initialValue={location.note} size={8} style={{}} />
                    </div>
                    <div style={{display:'inline-block',width:'77%',verticalAlign:'middle',textAlign:'center'}}>
                        <label style={{fontSize:'xx-small',fontWeight:'bold'}}>{location.name}</label><br/>
                        <label style={{color:'gray',fontSize:'xx-small'}}>{location.address.display_name}</label>
                    </div>
                </div>);
        }
    }

    const PartnersOptions = (partners,key,addresse_length=0)=>
    {
        return partners.reduce((result,current)=>{
            if(!!current.address)
            {
                
                let groupKey = current[current.address.ville];
                if(groupKey===undefined)
                    groupKey = current.address.ville
                const index = result.findIndex(item=>item.label===groupKey);
                if(index===-1)
                {
                    result.push({label:groupKey,options:[{value:current.address,partner_id:current.id,label:PartnerOption(current,true)}]});
                    if(!!panier.delivery_address && current.address.id===panier.delivery_address)
                    {
                        setSelAddress(result[result.length-1].options[0]);
                    }
                }
                else
                {
                    result[index].options.push({value:current.address,partner_id:current.id,label:PartnerOption(current,true)});
                    if(!!panier.delivery_address && current.address.id===panier.delivery_address)
                    {
                        setSelAddress(result[index].options[result[index].options.length-1]);
                    }
                }
            }
            return result;
        },[])
    }

    const LoadPartners = async ()=>{
        let arr = [];
        let index = 0;
        arr.push({label:'Mes Addresses',options:[]});
        User.locations.forEach(element => {
            arr[arr.length-1].options.push({value:element,label:PartnerOption(element,false)});
            index++;
            if(!!panier.delivery_address && element.id===panier.delivery_address)
            {
                setSelAddress(element);
            }
        });
        setMesAddresses([...arr]);
        await fetchData.PostData({},'partners/filter/all/').then((result)=>{
            if(result.result)
            {
                arr = [...arr,...PartnersOptions(result.partners,'ville',arr.length)];
            }
        })
        setAddresses([...arr]);
        setMapContext({...mapContex,points:[...arr]});
    }

    const LoadGifts = async ()=>{
        fetchData.GetData('user/gifts/meta/').then(result=>{
            console.log(result);
            if(result.result)
            {
                let arr = [];
                result.gift_cards.forEach((gift,index)=>{
                    arr.push({label:GiftOptionLabel(gift),value:gift})
                })
                setGiftCards(arr);
            }
        });
    }

    const UpadateAddresses = (CashPaymentMode = false)=>
    {
        try{
        if(CashPaymentMode)
        {
            mes_addresses.map(ad=>{
                const index_ = addresses.indexOf(ad);
                if(index_!==-1)
                    addresses.splice(index_,1);
            });
            if(selAddress.value.type==='user_point')
                setSelAddress(null);
        }
        else
        {
            mes_addresses.map(ad=>{
                if(!addresses.includes(ad))
                    addresses.push(ad)
            });
        }
        setAddresses([...addresses]);
        }
        catch{}
    }

    const is_ready_to_checkout = ()=>
    {
        for (let i=0;i<panier.articles.length;i++)
        {
            const article = panier.articles[i];
            if(article.deliver===null || article.deliver===undefined)
                return false;
            if(article.is_location && (article.location_dates.length===0))
                return false;
        }
        return true;
    }

    useEffect(()=>{
        fetchData.GetData('panier/').then((result)=>{
            console.log(result);
            if(result.result)
                setPanier({...result.panier});
        })
        LoadPartners();
        LoadGifts();
    },[]);

    useEffect(()=>{
        if (panier.gift_cards.length === 0) return;
        setGiftCards(prev => prev.map(gc => {
        const found = panier.gift_cards.find(g => g.id === gc.value.id);
        if (found) {
            return { ...gc,label:GiftOptionLabel(found), value: { ...gc.value, ...found } };  // met à jour l'élément
        }
        return gc; 
    }));

    },[panier.gift_cards])

    useEffect(()=>{
        fetchData.GetData('panier/').then((result)=>{
            if(result.result)
                setPanier({...panier,prices:result.panier.prices});
        });

    },[AppState.settings.devise])

    useEffect(()=>{
        addresses.forEach((element)=>{
            element.options.forEach((option)=>{
                if(!!panier.delivery_address && option.value.id===panier.delivery_address)
                {
                    setSelAddress(option);
                }
            });
        })
    },[addresses, panier.delivery_address])


    const SaveAddress = async(address)=>{
        let _panier = {'id':panier.id, articles:panier.articles,delivery_address:address};
        if(!!panier.partner)
            _panier = {..._panier, partner:panier.partner};
        await fetchData.PutData(_panier,'panier/').then((result)=>{
            if(result.result)
                setPanier({...result.panier});
        });
    }

    const SaveDeliver = async(deliver)=>{
        const _panier = {'id':panier.id, articles:panier.articles,deliver:deliver};
        await fetchData.PutData(_panier,'panier/').then((result)=>{
            if(result.result)
                setPanier({...result.panier});
        });
    }

    const SaveGiftCards = async(value)=>{
        const gifts = [];
        value.forEach((gift)=>{
            gifts.push(gift.value.id);
        })
        const _panier={'id':panier.id,gifts:gifts};
        await fetchData.PutData(_panier,'panier/').then((result)=>{
            console.log(result);
            if(result.result)
                setPanier({...result.panier});
        });
    }

    useEffect(()=>{
        if(refCashPaymentBtn.current!==null)
            refCashPaymentBtn.current.value = panier.prices.total;
    },[panier.prices.total])

    useEffect(()=>{
        SaveDeliver(panier.deliver);
    },[panier.deliver])

    useEffect(()=>{
        SaveAddress(panier.delivery_address);
    },[panier.delivery_address])
    

    const InfoCash = ()=>
    {
        if(panier.prices.total>1000)
            return(t("panier.paiement-help"));
        else
            return(t("panier.cash-help"))
    }

    const OrderCash = ()=>
    {
        
        fetchData.PostData({mode:'cash', articles:orArticlesRef.current},'payment/').then((result)=>{
            if(result.result)
            {
                navigator(`/payment/result/${result.status}/${result.order_id}`);
            }
            else
            {setNotif("echec");}
        }).catch(()=>{setNotif("echec");})
    }

    return(
        <div id="Panier">
            <div id="Panier-Container">
                <MobileView>
                    <div className="panier-title">
                        <img style={{width:'30px'}} src={panierIcon}/>
                        <span style={{fontWeight:'bold'}}>{t('panier.articles')}</span>
                    </div>
                </MobileView>
                {
                    panier.articles.map((item,index)=>{
                        return <ItemInPanier orArticlesRef={orArticlesRef} deliver={panier.deliver} key={index} panier={panier} setPanier={setPanier} Item={item} />
                    })
                }
            </div>
            <div id="PaymentBlock">
                <fieldset style={{borderRadius:'5px'}} id="DelivryBlock">
                    <div className="panier-title" style={{borderTopLeftRadius:'5px',borderTopRightRadius:'5px'}}>
                        <img src={deliveryIcon}/>
                        <span>{t("panier.livraison")}</span>
                    </div>  
                    <div className="w-64 mx-auto mt-5" style={{marginTop:'15px',width:'90%',margin:'auto'}}>
                        <label className="delivery-label" style={{color:'gray',fontSize:'small'}}>{t('user-info.addresse')} :</label>
                        <div className="delivery-select" style={{textAlign:'center'}}>
                            <Select 
                                value={selAddress}
                                isClearable 
                                placeholder={t('user-info.addresse')}
                                options={addresses}
                                styles={{menuPortal:(base)=>({...base, zIndex:9999})}} 
                                onChange={(value,action)=>{setPanier({...panier,delivery_address:value.value['id'],partner:value.partner_id});setSelAddress(value);}}   
                            />
                        </div>
                    </div>          
                    <div className="delivery-price" style={{marginTop:'auto',marginTop:'10px',textAlign:'center'}}>
                        <span><b><span>{panier.prices.delivery} {AppState.settings.devise==='euro'?'€':'KMF'}</span></b></span>
                    </div>   
                </fieldset>
                {is_ready_to_checkout() && 
                <fieldset id="PaymentInfo">
                    <div className="panier-title">
                        {/*<img src={cashIcon}/>*/}
                        <label style={{display:'block',marginTop:'5px',textAlign:'center'}}>{t("panier.paiement")}</label>
                    </div>
                    <div className="delivery-select" style={{textAlign:'center',width:'85%',margin:'auto',fontSize:'x-small'}}>
                        <Select
                            isMulti 
                            isClearable ={false}
                            isSearchable={false}
                            value={giftsCards.filter(gc => panier.gift_cards?.some(g => g.id === gc.value.id))}
                            placeholder={t('panier.cartes-cadeaux')}
                            options={giftsCards}
                            styles={{menuPortal:(base)=>({...base, zIndex:9999})}} 
                            onChange={(value,action)=>{SaveGiftCards(value)}}   
                        />
                    </div>
                    <div style={{marginTop:'20px',marginBottom:'20px'}}>
                        <div className="PaymentInfoItem"><label>{t('panier.articles')} : </label><span style={{float:'right'}}>{panier.prices.articles} {AppState.settings.devise==='euro'?'€':'KMF'}</span></div>
                        <div className="PaymentInfoItem"><label>{t('panier.livraison')} : </label><span style={{float:'right'}}>{panier.prices.delivery} {AppState.settings.devise==='euro'?'€':'KMF'}</span></div>
                        {(panier.prices.gifts>0)&&<div className="PaymentInfoItem" style={{color:'green',fontWeight:'bold'}}><label>{t('navigation.cadeaux')} : </label><span style={{float:'right'}}>{"- "+panier.prices.gifts} {AppState.settings.devise==='euro'?'€':'KMF'}</span></div>}
                        <div className="PaymentInfoItem-total" style={{fontWeight:'bold'}}><label>{t('panier.total')} </label><span style={{float:'right'}}>{panier.prices.total} {AppState.settings.devise==='euro'?'€':'KMF'}</span></div>
                    </div>
                    {(Number(panier.prices.total)!==0) &&
                    <Tabs style={{width:'90%',margin:'auto',marginTop:'10px'}}>
                        <TabList style={{width:'100%'}}>
                            <Tab style={{width:'20%'}} onClick={e=>{UpadateAddresses(false);}}>
                                <div style={{padding:'0px 5px 0px 5px'}}>
                                    {/*<img style={{width:'30px',padding:'5px',borderRadius:'5px', display:'inline-block',verticalAlign:'middle'}} src={creditIcon}/>*/}
                                    <span style={{display:'inline-block',verticalAlign:'middle',fontSize:'small'}}>{t('panier.carte')}</span>
                                </div>
                            </Tab>
                            <Tab style={{width:'20%'}} onClick={e=>{UpadateAddresses(true);}}>                            
                                <div style={{padding:'0px 5px 0px 5px'}}>
                                    {/*<img style={{width:'30px',padding:'5px',borderRadius:'5px', display:'inline-block',verticalAlign:'middle'}} src={dixmilleIcon}/>*/}
                                    <span style={{display:'inline-block',verticalAlign:'middle',fontSize:'small'}}>{t('panier.cash')}</span>
                                </div>
                            </Tab>
                        </TabList>
                        <TabPanel>
                            <div style={{margin:'15px auto 15px auto',width:'80%'}}>
                                <label style={{margin:'auto',display:'inline-block', fontWeight:'bold'}}>{t('panier.premier-paiement')} </label> <span style={{paddingLeft:'10px',float:'right',fontWeight:'bold'}}  dir="ltr">{panier.prices.total}{AppState.settings.devise==='euro' ? ' €' : ' KMF'}</span>
                            </div>
                            {  (notif!=="") &&
                                <div style={{margin:'15px auto 15px auto',width:'80%'}}>
                                    <label style={{color:'red',margin:'auto',display:'inline-block', fontWeight:'bold'}}>{t('panier.echec-paiement')} </label>
                                </div>
                            }
                            <Paypal orArticlesRef={orArticlesRef} User={User} prices={panier.prices} setNotif={setNotif} />
                        </TabPanel>
                        <TabPanel>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',marginTop:'10px',margin:'auto',marginBottom:'10px'}} className="PaymentInfoItem">
                                <img src={infoIcon} className="cash-info-icon" />
                                <div className="panier-info-cash">
                                    <span>{InfoCash()}</span>
                                </div>
                            </div>
                            <div className="PaymentInfoItem" style={{margin:'auto',marginTop:'15px',width:'80%'}}>
                                    <label style={{display:'inline-block', fontWeight:'bold'}}>{t('panier.premier-paiement')} : </label> <span style={{paddingLeft:'10px',float:'right',fontWeight:'bold'}}  dir="ltr">{panier.prices.total}{AppState.settings.devise==='euro' ? ' €' : ' KMF'}</span>
                                    {/*
                                    <div style={{display:'inline-block',maxWidth:'20%',marginLeft:'20px'}}>
                                        <input ref={refCashPaymentBtn} type="number" disabled={panier.prices.total<1000} style={{padding:'2px 5px 3px 5px',extAlign:'center',fontWeight:'bold',width:'60px',verticalAlign:'middle'}} min={panier.prices.total/2} max={panier.prices.total} defaultValue={panier.prices.total} />
                                    </div>*/
                                    }
                            </div>
                            <input onClick={e=>{OrderCash()}} className="btn-payment" type="button" value={"Ticket de Commande"}  />
                        </TabPanel>
                    </Tabs>}
                    {Number(panier.prices.total)===0 &&
                        <div style={{height:'40px',width:'90%',margin:'auto',marginBottom:'20px'}}>
                            <ButtonLoader onSubmit={e=>{OrderCash()}}  style={{backGroundColor:'lightgreen'}} text={t('panier.vaider-panier')}/>
                        </div>
                    }
                </fieldset>}
            </div>
        </div>);
}